// Auto-generated normalizer for table: CAR_BOOKING.ParametrosLaborales
export function parametrosLaboralesNormalize(row) {
  console.log(row)
  return {
    idParametro: row.idParametro ?? row.IdParametro ?? row['idParametroLaboral'] ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['idUnidadOrganizacional'] ?? 0,
    topeSemanalMin: row.topeSemanalMin ?? row.TopeSemanalMin ?? row['topeSemanalMin'] ?? 0,
    topeMensualMin: row.topeMensualMin ?? row.TopeMensualMin ?? row['topeMensualMin'] ?? 0,
    vigenciaDesde: row.vigenciaDesde ?? row.VigenciaDesde ?? row['vigenciaDesde'] ?? null,
    vigenciaHasta: row.vigenciaHasta ?? row.VigenciaHasta ?? row['vigenciaHasta'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
  };
}